import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.custom.background.area,
    width: '100%',
    minHeight: '64px',
    display: 'flex',
    alignItems: 'center',
    padding: `0 ${theme.spacing(2)}px`,

    '& .icon-toolbar': {
      margin: `0 ${theme.spacing(1)}px`,
      padding: theme.spacing(1),

      '&.menu': {
        marginLeft: theme.spacing(0),
      },
    },

    '& .logo-toolbar': {
      margin: `0 auto 0 ${theme.spacing(1)}px`,
      display: 'flex',

      '& > img': {
        maxWidth: 150,
        maxHeight: theme.spacing(5),
        objectFit: 'contain',

        '@media (max-width: 500px)': {
          maxWidth: 120,
        },
        '@media (max-width: 390px)': {
          display: 'none',
        },
      },
    },
  },
}));

export default styles;
